import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import { Button } from '@repo/ui';
import { useIsMobile } from '@repo/mui-config/hooks';

import { LoanProcessStatusIconWrapper } from '@/components/loan-process/loan-process-status-icon-wrapper';
import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';
import { useMainHubStoreActions } from '@/store/main-hub.store';
import { VIEW_TYPE } from '@/store/view.type';
import { useLoanProcessStore } from '@/components/loan-process/store/loan-process.store';
import { LoanProcessModalHeader } from '@/components/loan-process/loan-process-modal/loan-process-modal-header';

export function AgreementSuccessful() {
  const isMobile = useIsMobile();
  useLoanProcessSetCurrentModalState('AgreementSuccessful');
  const { t } = useTranslation();
  const {
    actions: { clearLoanProcessStore },
  } = useLoanProcessStore();
  const { setCurrentView } = useMainHubStoreActions();
  const closeModalAndGoToDashboard = () => {
    clearLoanProcessStore();
    setCurrentView(VIEW_TYPE.DASHBOARD);
  };

  return (
    <Box data-testid="agreement-successful-signed" sx={{ px: isMobile ? 2 : 4, py: 4 }}>
      <LoanProcessModalHeader containerSx={{ mb: isMobile ? 4 : 8 }} />
      <Stack
        alignContent="center"
        alignItems="center"
        gap={8}
        sx={{
          marginBottom: '64px',
        }}
      >
        <Typography component="p" textAlign="center" variant="h5">
          {t('loanProcess.loanSteps.successfulSigned.title')}
        </Typography>
        <LoanProcessStatusIconWrapper iconType="success">
          <CheckIcon />
        </LoanProcessStatusIconWrapper>
        <Typography sx={{ marginY: 2 }} textAlign="center">
          {t('loanProcess.loanSteps.successfulSigned.description')}
        </Typography>
      </Stack>
      <Button
        color="secondary"
        data-testid="agreement-successful-signed-button"
        fullWidth
        onClick={closeModalAndGoToDashboard}
        sx={{ paddingY: { md: '14px', xs: '8px' } }}
        variant="contained"
      >
        {t('loanProcess.loanSteps.successfulSigned.button')}
      </Button>
    </Box>
  );
}
